export default __webpack_public_path__ + "static/serti-1-d044fd55bb40408cbb0ab98ba659b7d9.png";